module.exports = __webpack_public_path__ + "img/friends.1c0f840e.svg";